export interface ProseMirrorMark {
    type: string;
    attrs?: Record<string, unknown>;
}

export interface ProseMirrorNode {
    type: string;
    content?: ProseMirrorNode[];
    marks?: ProseMirrorMark[];
    text?: string;
    attrs?: Record<string, unknown>;
}

type TranslationStatus = "upToDate" | "outdated" | "aiGenerated" | "manuallyEdited";

export interface RichTextTranslation {
    locale: string;
    content: ProseMirrorNode;
    status: TranslationStatus;
    translatedFromVersion: string;
    updatedAt: string;
}

export interface RichTextField {
    version: 2;
    sourceLocale: string;
    sourceContent: ProseMirrorNode;
    sourceContentHash: string;
    sourceUpdatedAt: string;
    translations: RichTextTranslation[];
}

export interface MessageTemplates {
    introductionMessage?: RichTextField;
    messageBookingClosed?: RichTextField;
    webConditions?: RichTextField;
    inquiryInfo?: RichTextField;
    messageDescription?: RichTextField;
}

export function resolveRichTextField(field: RichTextField, locale?: string): ProseMirrorNode {
    // The field arrives straight from the settings payload, where it is JSON stored in a string
    // column — a document written with a null Translations survives deserialization as null, and
    // the experience view renders this on its landing page, so a TypeError here takes the page
    // down rather than one form field.
    const translations: RichTextTranslation[] = field.translations ?? [];

    if (locale) {
        const exact = translations.find((t) => t.locale === locale);
        if (exact) return exact.content;

        const lang = locale.split("-")[0];
        const byLang = translations.find((t) => t.locale.split("-")[0] === lang);
        if (byLang) return byLang.content;
    }
    return field.sourceContent;
}
